import { Table } from "@/features/Table";
import { type Policy, policies_columns } from "./columns";
import { type FilterPoliciesSchema, FilterPolicies } from "./filter";

const client = "legacy-quantilia";
const table_name = "policies";

export const PoliciesTable = () => {
  return (
    <Table<Policy, FilterPoliciesSchema>
      label="Access Policies"
      client={client}
      table_name={table_name}
      columns={policies_columns}
      filter={<FilterPolicies />}
      disable_translations_request={true}
    />
  );
};
